/* unplugin-vue-components disabled */import script from "./RandomCoupon.vue?vue&type=script&setup=true&lang=js"
export * from "./RandomCoupon.vue?vue&type=script&setup=true&lang=js"

import "./RandomCoupon.vue?vue&type=style&index=0&id=626408b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626408b6"]])

export default __exports__